import { DEFAULT_TITLE } from '../constants';

export const title = (title?: string) => {
  return title ? `${title} | ${DEFAULT_TITLE}` : DEFAULT_TITLE;
};
